<template>
  <div class="tw-pt-1 tw-h-[60vh]">
    <TrustedContactsTable
      :additional-columns="additionalColumns"
      @row-click="clickedTrustedContactRow"
    >
      <template #no-trusted-contacts-found>
        <NoTrustedContactsFound />
      </template>
    </TrustedContactsTable>
  </div>
  <div class="tw-flex tw-items-center tw-justify-between tw-pt-4 tw-px-6">
    <WdsAlert
      class="tw-w-full"
      icon
      info
      :title="$t('Hiring someone for the first time?')"
      :description="$t('You\'ll need to add them as a trusted contact first')"
    >
      <template #footer>
        <WdsButton primary :href="laravelNamedRoute(namedRoutes.contacts.index, '')">
          {{ $t('Open trusted contacts') }}
        </WdsButton>
      </template>
    </WdsAlert>
  </div>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'
import { WdsButton, WdsAlert } from '@worksome/wds-components'
import { $t } from '@/composables/translation'
import TrustedContactsTable from '@/components/Contacts/CompanyFreelancer/PageContacts/TrustedContactsTable.vue'
import TdButton from '@/components/BaseDataTable/Cells/TdButton.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { TrustedContact } from '@/components/Job/hiring-types'
import NoTrustedContactsFound from '@/components/Contacts/CompanyFreelancer/NoTrustedContactsFound.vue'

interface Props {
  trustedContact?: TrustedContact
}

const emit = defineEmits(['cancel', 'confirm', 'update:trusted-contact'])

const props = defineProps<Props>()

const selectTrustedContact = (trustedContact) => {
  emit('update:trusted-contact', trustedContact)
  emit('confirm', trustedContact)
}

const trustedContactCanBeHired = (trustedContact): boolean => trustedContact.viewerCanOfferJob

const clickedTrustedContactRow = (trustedContact) => {
  if (trustedContactCanBeHired(trustedContact)) {
    selectTrustedContact(trustedContact)
  }
}

const additionalColumns = [
  {
    key: 'select-trusted-contact',
    renderUsing: {
      component: markRaw(TdButton),
      componentProps: (trustedContact) => ({
        primary: true,
        sm: true,
        onClick: () => selectTrustedContact(trustedContact),
        text: $t('Select'),
      }),
      shouldRender: trustedContactCanBeHired,
    },
    title: '',
    orderAble: false,
  },
]
</script>
